import styled from 'styled-components';
import {TableWrapper} from './TableWrapper.js';
import {StickyRowHeader, StickyRowHeaderFilter} from './table-sections/StickyRowHeader.js';
import {TableRow} from './table-sections/TableRow.js';

export const TableSafari = styled(TableWrapper)`
    ${StickyRowHeader} {
        z-index: 333;
        &::before {
            position: absolute;
            background: var(--app-background);
            height: 53px;
            content: '';
            z-index: -1;
            display: block;
            top: 0;
            bottom: 0;
            left: 0;
            width: 100%;
        }
        tr {
            position: -webkit-sticky;
        }
    }
    tbody ${TableRow}, ${StickyRowHeaderFilter} ${TableRow} {
        td,
        th {
            border-top: 1px solid var(--container-border-color-100);
            border-bottom: 1px solid var(--container-border-color-100);
            &:first-of-type {
                border-left: 1px solid var(--container-border-color-100);
            }
            &:last-of-type {
                border-right: 1px solid var(--container-border-color-100);
            }
        }
    }

    ${StickyRowHeaderFilter} {
        top: 53px !important;
    }
`;
